import { Fragment, h, render } from 'preact'
import { Footer, Header } from './layout.tsx'
import { LoginPage } from './pages/login.tsx'
import { VerifyLoginPage } from './pages/verify-login.tsx'
import { VerifyInvitationPage } from './pages/verify-invitation.tsx'
import { A, url } from '@01edu/signal-router'
import { user } from './lib/session.ts'
import { Projects } from './pages/project.tsx'
import { ProjectLicensesPage } from './pages/license.tsx'
import { LicenseUsagePage } from './pages/license-usage.tsx'
import { Notifications } from './ui/notifications.tsx'

Object.assign(globalThis, { h, Fragment })

const allowedRoutes = [
  '/',
  '/client-manager',
  '/verify-invitation',
]

const ErrorPage = (
  { title, description }: { title: string; description: string },
) => (
  <div class='hero bg-base-200 min-h-screen'>
    <div class='hero-content text-center'>
      <div class='max-w-md'>
        <h1 class='text-5xl font-bold'>{title}</h1>
        <p class='py-6'>
          {description}
        </p>
        <A href='/' class='btn btn-primary'>go to home page</A>
      </div>
    </div>
  </div>
)

const showPage = () => {
  if (!allowedRoutes.includes(url.path)) {
    return (
      <ErrorPage
        title='Page not found'
        description='The page you are looking for was not found'
      />
    )
  }
  if (url.params.token) return <VerifyLoginPage />
  if (url.params.tokeninvitation) return <VerifyInvitationPage />
  if (user.pending != null) return null
  if (!user.data) return <LoginPage />
  const projectId = Number(url.params.project)
  if (projectId) {
    const licenseId = Number(url.params.license)
    return licenseId ? <LicenseUsagePage /> : <ProjectLicensesPage />
  }
  return <Projects />
}

const App = () => (
  <div class='min-h-screen flex flex-col'>
    <Header />
    <main class='flex-grow bg-base-200'>
      {showPage()}
    </main>
    <Footer />
    <Notifications />
  </div>
)

const root = document.getElementById('app')
if (!root) throw Error('unable to find root element #app')
render(<App />, root)
